import { useLang } from "../../context/LanguageContext";
import { REVIEWS } from "../../data/content";
import { Reveal, SectionHeading } from "../Reveal";
import { Star, BadgeCheck } from "lucide-react";

const Stars = ({ rating }) => (
  <div className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} className={`h-4 w-4 ${n <= Math.round(rating) ? "fill-[#D9A05B] text-[#D9A05B]" : "text-stone-300"}`} />
    ))}
  </div>
);

export const Reviews = () => {
  const { t } = useLang();
  return (
    <section id="reviews" className="scroll-mt-20 bg-[#F3EFEA] px-4 sm:px-8 py-20 lg:py-28">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
            <SectionHeading eyebrow={t("reviews.eyebrow")} title={t("reviews.title")} />
            <div className="flex items-center gap-4 rounded-2xl bg-white px-6 py-4 shadow-sm">
              <span className="font-serif text-4xl font-semibold text-stone-900">{t("reviews.score")}</span>
              <div>
                <Stars rating={5} />
                <p className="mt-1 text-xs text-stone-500">{t("reviews.scoreNote")}</p>
              </div>
            </div>
          </div>
        </Reveal>

        <div className="mt-10 grid gap-5 sm:grid-cols-2">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.id} delay={Math.min(i * 0.07, 0.3)}>
              <figure
                data-testid={`review-${r.id}`}
                className="flex h-full flex-col rounded-2xl border border-stone-200/80 bg-white p-6"
              >
                <div className="flex items-center justify-between">
                  <Stars rating={r.rating} />
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-[#5F6B52]">
                    <BadgeCheck className="h-4 w-4" /> {t("reviews.verified")}
                  </span>
                </div>
                <blockquote className="mt-4 flex-1 font-serif text-lg italic leading-relaxed text-stone-700">
                  “{r.text}”
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-stone-100 pt-4">
                  <span className="text-2xl">{r.flag}</span>
                  <div className="flex-1">
                    <p className="text-sm font-semibold text-stone-800">{r.name}</p>
                  </div>
                  <span
                    data-testid={`review-source-${r.id}`}
                    className={`rounded-full px-2.5 py-1 text-xs font-semibold ${
                      r.source === "Airbnb" ? "bg-[#FF5A5F]/12 text-[#E0484D]" : "bg-[#003B95]/10 text-[#003B95]"
                    }`}
                  >
                    {r.source}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
